import { getSubscriptionsRepository, SubscriptionResponse, CreateSubscriptionDto } from '../repositories/subscriptions.repository';
import { ApiError } from './types';

export class SubscriptionService {
  private static get repository() {
    return getSubscriptionsRepository();
  }

  /**
   * Verifica se a empresa tem uma assinatura ativa
   * @returns Promise com dados da assinatura ativa ou null se não houver
   */
  static async checkActiveSubscription(): Promise<SubscriptionResponse | null> {
    try {
      return await this.repository.checkActiveSubscription();
    } catch (error: any) {
      // Se houver qualquer erro, retorna null silenciosamente
      // O endpoint pode não estar implementado ainda ou não há assinatura
      return null;
    }
  }

  /**
   * Verifica se existe assinatura ativa por CNPJ
   * @param cnpj CNPJ da empresa (com ou sem formatação)
   * @returns Promise com dados da assinatura ativa ou null se não houver
   */
  static async checkActiveSubscriptionByCnpj(cnpj: string): Promise<SubscriptionResponse | null> {
    try {
      return await this.repository.checkActiveSubscriptionByCnpj(cnpj);
    } catch (error: any) {
      // Se houver qualquer erro, retorna null silenciosamente
      return null;
    }
  }

  /**
   * Criar nova assinatura
   * @returns Promise com dados da assinatura criada
   */
  static async create(data: CreateSubscriptionDto): Promise<SubscriptionResponse> {
    try {
      return await this.repository.create(data);
    } catch (error: any) {
      const apiError = this.handleApiError(error);
      throw new Error(apiError.message);
    }
  }

  /**
   * Trata erros da API
   */
  private static handleApiError(error: any): ApiError {
    if (error.response?.data) {
      return {
        message: error.response.data.message || error.message || 'Erro na requisição',
        statusCode: error.response.status || error.statusCode || 500,
        error: error.response.data.error || error.error || 'Unknown Error',
      };
    }

    if (error.message) {
      return {
        message: error.message,
        statusCode: 500,
        error: 'Network Error',
      };
    }

    return {
      message: 'Erro de conexão com o servidor',
      statusCode: 500,
      error: 'Network Error',
    };
  }
}

